module.exports = __webpack_public_path__ + "img/pic_1.e0d46e5b.png";